import React, { FunctionComponent } from 'react';

export enum ProfileMainTabType {
    PROJECT = 'PROJECT',
    PORTFOLIO = 'PORTFOLIO'
}

interface ProfileMainTabsProps {
    activeTab: ProfileMainTabType;
    setActiveTab: (tab: ProfileMainTabType) => void;
}

const ProfileMainTabs: FunctionComponent<ProfileMainTabsProps> = ({
    activeTab,
    setActiveTab
}) => {
    const isActive = (tab: ProfileMainTabType) => activeTab === tab;
    const getTabClassName = (tab: ProfileMainTabType) =>
        `profile-main-tabs__tab ${isActive(tab) ? 'is-active' : ''}`;

    return (
        <div className="profile-main-tabs">
            <div className="profile-main-tabs__container">
                <button
                    className={getTabClassName(ProfileMainTabType.PROJECT)}
                    onClick={() => setActiveTab(ProfileMainTabType.PROJECT)}
                >
                    <span>Projects</span>
                </button>
                <button
                    className={getTabClassName(ProfileMainTabType.PORTFOLIO)}
                    onClick={() => setActiveTab(ProfileMainTabType.PORTFOLIO)}
                >
                    <span>Portfolio</span>
                </button>
            </div>
        </div>
    );
};

export default ProfileMainTabs;